export class MergeDate {
  static merge({ tableData, middleLang, BPList }) {
    const mergeFirst = this.mergeTableDataMiddleLang({ tableData, middleLang })
    return this.mergeFirstBPList({ firstMerged: mergeFirst, BPList })
  }

  static mergeTableDataMiddleLang({ tableData, middleLang }) {
    return tableData.map(IO => {
      const tableTargetIOId = IO.insertionOrderId

      const res = middleLang.filter(IO => {
        return IO.IOId === tableTargetIOId
      })

      if (!res.length) return IO

      IO.BPIds = res[0].BPIds
      return IO
    })
  }

  static mergeFirstBPList({ firstMerged, BPList }) {
    if (!BPList) return

    return firstMerged.map(firstIO => {
      const targetIO = BPList.find(IO => IO.id === firstIO.insertionOrderId)

      if (!targetIO) return firstIO

      firstIO.BPIds.map(firstBP => {
        const targetBP = targetIO.billingPeriods.find(
          targetBP => targetBP.id === firstBP.BPId,
        )

        if (!targetBP) return firstBP

        firstBP.startDate = targetBP.startDate
        firstBP.endDate = targetBP.endDate
        return firstBP
      })

      return firstIO
    })
  }
}

export const mergeData = ({ tableData, middleLang, BPList }) => {
  return MergeDate.merge({ tableData, middleLang, BPList })
}
